/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Email1Inputs */

const id_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const ms_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emel:`)
};

const da_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const de_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail:`)
};

const en_us2_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const es_es2_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico:`)
};

const es_mx2_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico:`)
};

const fil_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const fr_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courriel :`)
};

const it_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const hu_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const nl_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const no_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

const pl_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const pt_br2_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const pt_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const ro_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const fi_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti:`)
};

const sv_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post:`)
};

const vi_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const tr_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta:`)
};

const cs_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail:`)
};

const bg_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейл:`)
};

const ru_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта:`)
};

const uk_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Електронна пошта:`)
};

const ar_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني:`)
};

const hi_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल:`)
};

const th_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล:`)
};

const ja_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール：`)
};

const zh_cn2_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱：`)
};

const zh_hant1_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件：`)
};

const ko_misc_fairuse_email1 = /** @type {(inputs: Misc_Fairuse_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Misc_Fairuse_Email1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_email1 = /** @type {((inputs?: Misc_Fairuse_Email1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Email1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_email1(inputs)
	if (locale === "ms") return ms_misc_fairuse_email1(inputs)
	if (locale === "da") return da_misc_fairuse_email1(inputs)
	if (locale === "de") return de_misc_fairuse_email1(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_email1(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_email1(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_email1(inputs)
	if (locale === "fil") return fil_misc_fairuse_email1(inputs)
	if (locale === "fr") return fr_misc_fairuse_email1(inputs)
	if (locale === "it") return it_misc_fairuse_email1(inputs)
	if (locale === "hu") return hu_misc_fairuse_email1(inputs)
	if (locale === "nl") return nl_misc_fairuse_email1(inputs)
	if (locale === "no") return no_misc_fairuse_email1(inputs)
	if (locale === "pl") return pl_misc_fairuse_email1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_email1(inputs)
	if (locale === "pt") return pt_misc_fairuse_email1(inputs)
	if (locale === "ro") return ro_misc_fairuse_email1(inputs)
	if (locale === "fi") return fi_misc_fairuse_email1(inputs)
	if (locale === "sv") return sv_misc_fairuse_email1(inputs)
	if (locale === "vi") return vi_misc_fairuse_email1(inputs)
	if (locale === "tr") return tr_misc_fairuse_email1(inputs)
	if (locale === "cs") return cs_misc_fairuse_email1(inputs)
	if (locale === "bg") return bg_misc_fairuse_email1(inputs)
	if (locale === "ru") return ru_misc_fairuse_email1(inputs)
	if (locale === "uk") return uk_misc_fairuse_email1(inputs)
	if (locale === "ar") return ar_misc_fairuse_email1(inputs)
	if (locale === "hi") return hi_misc_fairuse_email1(inputs)
	if (locale === "th") return th_misc_fairuse_email1(inputs)
	if (locale === "ja") return ja_misc_fairuse_email1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_email1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_email1(inputs)
	return ko_misc_fairuse_email1(inputs)
});
export { misc_fairuse_email1 as "misc.fairUse.email" }